export enum StatusRule {
    ActiveByDefault = 1,
    InactiveByDefault = 2,
    Remind = 3
}

(StatusRule as any).__typeName = 'StatusRule';